var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "numbering-form" },
    [
      _c(
        "panel-competition-form-box",
        { staticClass: "numbering-form__box mab16" },
        [
          _c(
            "div",
            { staticClass: "col-12 col-lg-8" },
            [
              _c("p", { staticClass: "form-input__label" }, [
                _vm._v("Metoda nadawania numerów startowych"),
              ]),
              _c("panel-input-base-radio", {
                attrs: {
                  name: "autoNumbers",
                  option: { value: "auto", title: "Automatyczna" },
                },
                model: {
                  value: _vm.form.autoNumbers,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "autoNumbers", $$v)
                  },
                  expression: "form.autoNumbers",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "numbering-form__nested",
                  class: { "numbering-form__nested--disabled": !_vm.isAuto },
                },
                [
                  _c(
                    "panel-input-checkbox",
                    {
                      attrs: {
                        "checkbox-value": true,
                        name: "autoNumbersEmail",
                        variant: "white",
                        value: false,
                      },
                      model: {
                        value: _vm.form.autoNumbersEmail,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "autoNumbersEmail", $$v)
                        },
                        expression: "form.autoNumbersEmail",
                      },
                    },
                    [
                      _vm._v(
                        " Wysyłaj numer startowy w automatycznej wiadomości z potwierdzeniem rejestracji "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("panel-input-base-radio", {
                attrs: {
                  name: "autoNumbers",
                  option: { value: "manual", title: "Ręczna" },
                },
                model: {
                  value: _vm.form.autoNumbers,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "autoNumbers", $$v)
                  },
                  expression: "form.autoNumbers",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "numbering-form__nested",
                  class: { "numbering-form__nested--disabled": _vm.isAuto },
                },
                [
                  _c("panel-input-base-radio", {
                    attrs: {
                      name: "numbersOrder",
                      option: {
                        value: "date",
                        title: "Według daty rejestracji / opłaty",
                      },
                    },
                    model: {
                      value: _vm.form.numbersOrder,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "numbersOrder", $$v)
                      },
                      expression: "form.numbersOrder",
                    },
                  }),
                  _c("panel-input-base-radio", {
                    attrs: {
                      name: "numbersOrder",
                      option: { value: "alphabetic", title: "Alfabetycznie" },
                    },
                    model: {
                      value: _vm.form.numbersOrder,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "numbersOrder", $$v)
                      },
                      expression: "form.numbersOrder",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "col-12 col-lg-4" }, [
            _c("p", { staticClass: "form-input__hint" }, [
              _vm._v(
                " Automatyczne nadawanie numerów startowych odbywa się w momencie rejestracji lub opłaty za rejestrację, przez uczestnika. "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                " Ręczne nadanie numerów pozwala przypisać numery alfabetycznie wg nazwisk uczestników. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "panel-competition-form-box",
        { staticClass: "numbering-form__box mab16" },
        [
          _c(
            "div",
            { staticClass: "col-12 col-lg-8" },
            [
              _c("p", { staticClass: "form-input__label" }, [
                _vm._v("Nadawanie numerów w klasyfikacjach płatnych"),
              ]),
              _c("panel-input-base-radio", {
                attrs: {
                  name: "numbersOnlyPayed",
                  option: { value: "all", title: "Wszystkim zarejestrowanym" },
                },
                model: {
                  value: _vm.form.numbersOnlyPayed,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "numbersOnlyPayed", $$v)
                  },
                  expression: "form.numbersOnlyPayed",
                },
              }),
              _c("panel-input-base-radio", {
                attrs: {
                  name: "numbersOnlyPayed",
                  option: { value: "paid", title: "Tylko opłaconym" },
                },
                model: {
                  value: _vm.form.numbersOnlyPayed,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "numbersOnlyPayed", $$v)
                  },
                  expression: "form.numbersOnlyPayed",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "col-12 col-lg-4" }, [
            _c("p", { staticClass: "form-input__hint" }, [
              _vm._v(
                " Numery mogą być nadawane wszystkim zarejestrowanym uczestnikom lub tylko opłaconym. Uczestnicy w klasyfikacjach bezpłatnych traktowani są jak opłaceni. "
              ),
            ]),
          ]),
        ]
      ),
      _vm.hasCycle
        ? _c(
            "panel-competition-form-box",
            { staticClass: "numbering-form__box mab16" },
            [
              _c(
                "div",
                { staticClass: "col-12 col-lg-8" },
                [
                  _c("p", { staticClass: "form-input__label" }, [
                    _vm._v("Zawody cykliczne"),
                  ]),
                  _c("panel-input-base-radio", {
                    attrs: {
                      name: "numbersUsePrevious",
                      option: {
                        value: "previous",
                        title:
                          "Nadawaj uczestnikom ich numery z poprzednich zawodów w tym cyklu",
                      },
                    },
                    model: {
                      value: _vm.form.numbersUsePrevious,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "numbersUsePrevious", $$v)
                      },
                      expression: "form.numbersUsePrevious",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "numbering-form__nested",
                      class: {
                        "numbering-form__nested--disabled":
                          _vm.form.numbersUsePrevious !== "previous",
                      },
                    },
                    [
                      _c(
                        "panel-input-checkbox",
                        {
                          attrs: {
                            "checkbox-value": true,
                            name: "numbersOnlyPrevious",
                            variant: "white",
                            value: false,
                          },
                          model: {
                            value: _vm.form.numbersOnlyPrevious,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "numbersOnlyPrevious", $$v)
                            },
                            expression: "form.numbersOnlyPrevious",
                          },
                        },
                        [_vm._v(" Pomiń zawodników bez numeru ")]
                      ),
                    ],
                    1
                  ),
                  _c("panel-input-base-radio", {
                    attrs: {
                      name: "numbersUsePrevious",
                      option: { value: "new", title: "Nadawaj numery na nowo" },
                    },
                    model: {
                      value: _vm.form.numbersUsePrevious,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "numbersUsePrevious", $$v)
                      },
                      expression: "form.numbersUsePrevious",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "col-12 col-lg-4" }, [
                _c("p", { staticClass: "form-input__hint" }, [
                  _vm._v(
                    " Uczestnicy mogą otrzymać ten sam numer, którym posługiwali się w poprzednich zawodach z tego samego cyklu. "
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "panel-competition-form-box",
        { staticClass: "numbering-form__box mab16" },
        [
          _c(
            "div",
            { staticClass: "col-12 col-lg-8" },
            [
              _c("p", { staticClass: "form-input__label" }, [
                _vm._v("Istniejące numery"),
              ]),
              _c("panel-input-base-radio", {
                attrs: {
                  name: "numbersKeep",
                  option: { value: "keep", title: "Zachowaj" },
                },
                model: {
                  value: _vm.form.numbersKeep,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "numbersKeep", $$v)
                  },
                  expression: "form.numbersKeep",
                },
              }),
              _c("panel-input-base-radio", {
                attrs: {
                  name: "numbersKeep",
                  option: { value: "reassign", title: "Nadaj na nowo" },
                },
                model: {
                  value: _vm.form.numbersKeep,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "numbersKeep", $$v)
                  },
                  expression: "form.numbersKeep",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "col-12 col-lg-4" }, [
            _c("p", { staticClass: "form-input__hint" }, [
              _vm._v(
                " Numery mogą być nadawane wszystkim uczestnikom lub tylko uczestnikom bez numeru. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "panel-competition-form-box",
        {
          staticClass: "numbering-form__box numbering-form__box--params mab16",
        },
        [
          _c(
            "div",
            { staticClass: "col-12 col-lg-8 numbering-form__params-main" },
            [
              _c("p", { staticClass: "form-input__label" }, [
                _vm._v("Parametry nadawania numerów"),
              ]),
              _c("div", { staticClass: "numbering-form__params-body" }, [
                _c("div", { staticClass: "numbering-form__presets-block" }, [
                  _c("p", { staticClass: "numbering-form__preset-label" }, [
                    _vm._v("Wybierz z predefiniowanych parametrów"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "numbering-form__presets" },
                    _vm._l(_vm.presets, function (preset) {
                      return _c(
                        "base-button",
                        {
                          key: preset.id,
                          staticClass: "numbering-form__preset",
                          class: {
                            "numbering-form__preset--active":
                              _vm.activePreset === preset.id,
                          },
                          attrs: { short: "" },
                          on: {
                            click: function ($event) {
                              return _vm.applyPreset(preset.id)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(preset.label) + " ")]
                      )
                    }),
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "numbering-form__table" },
                  [
                    _c("div", { staticClass: "numbering-form__table-head" }, [
                      _c(
                        "div",
                        { staticClass: "numbering-form__col-name-head" },
                        [_vm._v("Klasyfikacja")]
                      ),
                      _c("div", { staticClass: "numbering-form__col-ranges" }, [
                        _c("div", { staticClass: "numbering-form__col-from" }, [
                          _vm._v("Od nr"),
                        ]),
                        _c("div", {
                          staticClass:
                            "numbering-form__col-sep numbering-form__col-sep--head",
                        }),
                        _c("div", { staticClass: "numbering-form__col-to" }, [
                          _vm._v("Do nr"),
                        ]),
                      ]),
                    ]),
                    _vm._l(_vm.form.classifications, function (row, index) {
                      return _c(
                        "div",
                        {
                          key: row.id,
                          staticClass: "numbering-form__row",
                          class: {
                            "numbering-form__row--disabled": !row.enabled,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "numbering-form__row-main" },
                            [
                              _c(
                                "label",
                                { staticClass: "numbering-form__check" },
                                [
                                  _c("input", {
                                    attrs: { type: "checkbox" },
                                    domProps: { checked: row.enabled },
                                    on: {
                                      change: function ($event) {
                                        return _vm.toggleClassification(
                                          index,
                                          $event.target.checked
                                        )
                                      },
                                    },
                                  }),
                                  _c("span", {
                                    staticClass: "numbering-form__check-box",
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "numbering-form__col-body" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "numbering-form__col-name" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "numbering-form__cls-name",
                                        },
                                        [_vm._v(_vm._s(row.name))]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "numbering-form__cls-meta",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-user",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(row.playersTotal)),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  row.playersLimit > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "numbering-form__col-limit",
                                        },
                                        [
                                          _c("p", [
                                            _vm._v("Limit uczestników"),
                                          ]),
                                          _c("p", [
                                            _vm._v(_vm._s(row.playersLimit)),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "numbering-form__col-ranges",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "numbering-form__col-from",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: row.numbersMin,
                                                expression: "row.numbersMin",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            staticClass:
                                              "numbering-form__number-input",
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              disabled: !row.enabled,
                                            },
                                            domProps: { value: row.numbersMin },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  row,
                                                  "numbersMin",
                                                  _vm._n($event.target.value)
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "numbering-form__col-sep",
                                        },
                                        [_vm._v("…")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "numbering-form__col-to",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: row.numbersMax,
                                                expression: "row.numbersMax",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            staticClass:
                                              "numbering-form__number-input",
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              disabled: !row.enabled,
                                            },
                                            domProps: { value: row.numbersMax },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  row,
                                                  "numbersMax",
                                                  _vm._n($event.target.value)
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm.issuesById[row.id]
                            ? _c(
                                "div",
                                {
                                  staticClass: "numbering-form__callout",
                                  class: `numbering-form__callout--${
                                    _vm.issuesById[row.id].type
                                  }`,
                                },
                                [
                                  _vm.issuesById[row.id].type === "error"
                                    ? _c("exclamation-triangle", {
                                        attrs: {
                                          width: 24,
                                          height: 24,
                                          fill: "#455A64",
                                        },
                                      })
                                    : _c("exclamation-mark", {
                                        attrs: {
                                          width: 24,
                                          height: 24,
                                          fill: "#455A64",
                                        },
                                      }),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.issuesById[row.id].text)),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "col-12 col-lg-4" }, [
            _c("p", { staticClass: "form-input__hint" }, [
              _vm._v(
                " Możesz podzielić pulę numerów startowych pomiędzy klasyfikacje. Wybierz predefiniowaną metodę dzielenia lub ustaw własne parametry. "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "numbering-form__actions mat24 mab24" },
        [
          _c(
            "base-button",
            {
              attrs: {
                btn1: "",
                loading: _vm.assigning,
                disabled: _vm.saving || _vm.assigning || _vm.hasBlockingErrors,
              },
              on: { click: _vm.onAssign },
            },
            [_vm._v(" Nadaj numery i zapisz ")]
          ),
          _c(
            "base-button",
            {
              attrs: {
                btn2: "",
                loading: _vm.saving,
                disabled: _vm.saving || _vm.assigning || _vm.hasBlockingErrors,
              },
              on: { click: _vm.onSave },
            },
            [_vm._v(" Zapisz ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }